import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  uploader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    '@media(hover: hover)': {
      '&:hover': {
        '& $uploaderIcon path': {
          fill: '#282b36',
        },
        '& $uploaderTitle': {
          color: '#282b36',
        },
      },
    },
  },
  uploaderTitle: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: 1.25,
    color: '#545869',
  },
  uploaderText: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 4,
    fontSize: 10,
    lineHeight: 1.2,
    color: '#545869',
  },
  inputFile: {
    display: 'none',
  },
  uploaderIcon: {
    marginInlineEnd: 8,
    '& path': {
      fill: '#545869',
    },
    '& svg': {
      width: 30,
    },
  },
});

export default useStyles;
